import {
  handleActions,
  combineActions,
} from 'redux-actions';
import update from 'immutability-helper';
import TeamActionCreators from '../actions/TeamActionCreators';

const {
  getTeamMembersRequest,
  getTeamMembersSuccess,
  getTeamMembersFailure,
  deleteMemberRequest,
  deleteMemberSuccess,
  deleteMemberFailure,
  subscribeRequest,
  subscribeSuccess,
  subscribeFailure,
  getPendingSubscriptionsRequest,
  getPendingSubscriptionsSuccess,
  getPendingSubscriptionsFailure,
  approveSubscriptionRequest,
  approveSubscriptionSuccess,
  approveSubscriptionFailure,
  declineSubscriptionRequest,
  declineSubscriptionSuccess,
  declineSubscriptionFailure,
  getPaymentHistoryRequest,
  getPaymentHistorySuccess,
  getPaymentHistoryFailure,
} = TeamActionCreators;

const initialState = {
  isLoading: false,
  isSubscriptionLoading: false,
  teamMembers: [],
  subscriptions: [],
  payments: [],
};

export default handleActions({
  [combineActions(
    getTeamMembersRequest,
    deleteMemberRequest,
  )]: state => update(state, {
    isLoading: { $set: true },
  }),
  [getTeamMembersSuccess]: (state, { payload }) => update(state, {
    isLoading: { $set: false },
    teamMembers: { $set: payload },
  }),
  [combineActions(
    deleteMemberSuccess,
    deleteMemberFailure,
    getTeamMembersFailure,
  )]: state => update(state, {
    isLoading: { $set: false },
  }),
  [combineActions(
    subscribeRequest,
    getPendingSubscriptionsRequest,
    approveSubscriptionRequest,
    declineSubscriptionRequest,
    getPaymentHistoryRequest,
  )]: state => update(state, {
    isSubscriptionLoading: { $set: true },
  }),
  [getPendingSubscriptionsSuccess]: (state, { payload }) => update(state, {
    isSubscriptionLoading: { $set: false },
    subscriptions: { $set: payload },
  }),
  [getPaymentHistorySuccess]: (state, { payload }) => update(state, {
    isSubscriptionLoading: { $set: false },
    payments: { $set: payload },
  }),
  [combineActions(
    subscribeSuccess,
    approveSubscriptionSuccess,
    declineSubscriptionSuccess,
    subscribeFailure,
    getPendingSubscriptionsFailure,
    approveSubscriptionFailure,
    declineSubscriptionFailure,
    getPaymentHistoryFailure,
  )]: state => update(state, {
    isSubscriptionLoading: { $set: false },
  }),
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/team.js